import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as r, createElementBlock as n, normalizeClass as d, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconSimultaneousRing",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, l, _, f, a) {
  return r(), n("svg", {
    "aria-label": l.ariaLabel,
    class: d([a.iconSizeClass, "d-icon d-icon--simultaneous-ring"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Simultaneous Ring",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.008 2c.025.338.098.826.292 1.379l.587-.492L5.667 2h-.66Zm.725 2.32.827-.692a.937.937 0 0 0 .307-.944l-.242-.974-.47.116.47-.116A.935.935 0 0 0 5.718 1H4.9c-.48 0-.926.383-.899.925a6.51 6.51 0 0 0 1.903 4.244c1.575 1.583 3.495 1.976 4.356 2.075.566.065.99-.394.99-.901V6.55a.936.936 0 0 0-.708-.908l-1-.25a.933.933 0 0 0-.888.246l-.784.788a5.955 5.955 0 0 1-1.258-.962 5.6 5.6 0 0 1-.88-1.144Zm3.1 2.557a6.73 6.73 0 0 0 1.417.358v-.636l-.914-.228-.504.506Zm.466-.516ZM2.008 4.5c.025.338.098.826.292 1.379l.587-.492-.22-.887h-.66Zm.91.861Zm-.185 1.46.827-.693a.937.937 0 0 0 .307-.944l-.242-.974-.485.12.485-.12a.935.935 0 0 0-.907-.71H1.9c-.48 0-.926.383-.899.925a6.51 6.51 0 0 0 1.903 4.244c1.575 1.583 3.495 1.976 4.356 2.075.566.065.99-.394.99-.901V9.05a.936.936 0 0 0-.708-.908l-1-.25a.933.933 0 0 0-.888.246l-.784.788a5.955 5.955 0 0 1-1.258-.962 5.6 5.6 0 0 1-.88-1.144Zm3.1 2.556a6.73 6.73 0 0 0 1.417.358v-.636l-.914-.228-.504.506Zm.466-.516Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const Z = /* @__PURE__ */ s(c, [["render", u]]);
export {
  Z as default
};
//# sourceMappingURL=simultaneous-ring.js.map
